import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from "vue";
import { useHead } from "@unhead/vue";
import Navbar from "@/components/navigation/Navbar.vue";
import Footer from "@/components/navigation/Footer.vue";
import { useMiscStore } from '@/stores/misc';
import Spinner from "@/components/spinner/Spinner.vue";
import { useRoute } from 'vue-router';
import brand from "@/brand";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} | ${brand.name}` : brand.name;
  },
  meta: [{ name: "description", content: "" }],
});

const miscStore = useMiscStore();
const route = useRoute();
const containerBlacklist = ["ViewInvoice"]

// onMounted(() => {
//   window.removeEventListener("storage", (e) => syncLocalStorage(e));
//   window.addEventListener("storage", (e) => syncLocalStorage(e));
// });

// function syncLocalStorage(e: any): any {
//   localStorage.setItem(e.key, e.newValue);
// }

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar),
    _createElementVNode("main", {
      class: _normalizeClass({ 'container' : !containerBlacklist.includes(_unref(route).name as string)})
    }, [
      _createVNode(Spinner, {
        isAbsolute: true,
        visible: _unref(miscStore).isLoading || _unref(miscStore).isLoadingOverride
      }, null, 8, ["visible"]),
      _createVNode(_component_router_view)
    ], 2),
    _createVNode(Footer)
  ], 64))
}
}

})